import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "p-g01-item-carousel__button p-g01-item-carousel__button--prev" }
const _hoisted_2 = { class: "p-g01-item-carousel__button__icon__wrap" }
const _hoisted_3 = { class: "p-g01-item-carousel__button p-g01-item-carousel__button--next" }
const _hoisted_4 = { class: "p-g01-item-carousel__button__icon__wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowLeft = _resolveComponent("IconArrowLeft")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_IconArrowRight = _resolveComponent("IconArrowRight")!
  const _component_G01IconRanking = _resolveComponent("G01IconRanking")!
  const _component_ItemListPanel = _resolveComponent("ItemListPanel")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["p-g01-item-carousel", [`p-g01-item-carousel--${_ctx.carouselName}`]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_IconBase, {
          class: "p-g01-item-carousel__button__icon",
          "view-box": "0 0 24 24",
          width: "24",
          height: "24"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconArrowLeft)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_IconBase, {
          class: "p-g01-item-carousel__button__icon",
          "view-box": "0 0 24 24",
          width: "24",
          height: "24"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconArrowRight)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_Swiper, {
      class: "swiper",
      options: _ctx.swiperOption
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, key) => {
          return (_openBlock(), _createBlock(_component_SwiperSlide, { key: key }, {
            default: _withCtx(() => [
              _createVNode(_component_G01IconRanking, {
                num: key + 1,
                class: "p-g01-item-carousel__ranking_icon"
              }, null, 8, ["num"]),
              _createVNode(_component_ItemListPanel, {
                id: item.premium.id,
                "img-path": _ctx.getImagePath(item.premium),
                name: item.premium.name,
                point: item.point_required,
                "discount-rate": 0,
                "is-favorite": item.is_new,
                color: _ctx.getColor(item),
                status: _ctx.status(item),
                stock: item.quantity,
                "stock-control": item.is_quantity_control
              }, null, 8, ["id", "img-path", "name", "point", "is-favorite", "color", "status", "stock", "stock-control"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["options"])
  ], 2))
}